import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectWorksheet } from 'services/worksheet/selectors';
import get from 'lodash.get';
import keyBy from 'lodash.keyby';
import sortBy from 'lodash.sortby';

import { AppState } from 'services/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { OwnProps } from './index';

const selectPageIndex = (
    state: AppState,
    props: OwnProps
): WorksheetPageIndex => props.pageIndex;

const selectSprayWorksheetProducts = createDeepEqualSelector(
    selectWorksheet,
    selectPageIndex,
    (sprayWorksheetState, index) =>
        sortBy(
            get(sprayWorksheetState, ['pages', index, 'sprayEventProducts']),
            'orderIndex'
        )
);

const makeSelectSprayWorksheetProducts =
    (): typeof selectSprayWorksheetProducts => selectSprayWorksheetProducts;

const selectSprayWorksheetProductsKeyedById = createDeepEqualSelector(
    selectSprayWorksheetProducts,
    (productsState) => keyBy(productsState, 'id')
);

export {
    selectPageIndex,
    selectSprayWorksheetProductsKeyedById,
    makeSelectSprayWorksheetProducts,
    selectSprayWorksheetProducts
};
